import {combineLatest} from 'rxjs';
import {map} from 'rxjs/operators';
import {accountUtil} from '@px/helper/account';
import {contract$} from '@px/streams/contract';
import {accounts$} from './accounts';

export const account$ = combineLatest([contract$, accounts$]).pipe(map(([contract, accounts]) => accountUtil.findAccount(accounts, contract.settleCurrency)));
